module.exports = __webpack_public_path__ + "img/dark-rating.c7dbca9d.png";